define([
  'jquery',
  'pubsub',
  'wcs.product-price-service'
], function($, pubsub, priceService) {

  // Name the plugin
  var PLUGIN_IDENTIFIER = 'klarnaLoader';
  var DEBUG = false;

  // Create the function that will be bound to JQuery
  var vfdpPlugin = function(element, options) {
    this.element = element;
    this.options = options;
  };

  // Define the plugin's prototype and defaults
  vfdpPlugin.prototype = {
    defaults: {
      priceID : '#klarna-pdp-product-price',//the element the price gets injected into
      detailsBtn : '.pdp-klarna-details',//the details link that launches the modal
      modalID: '#klarna-price-interstitial',//the id of the modal to launch
      CURRENCY: '$',//the default currency symbol in case it isn't passed into config
      klarnaDiv: '.pdp-klarna',//the div that holds our klarna messaging
      modalPriceID: '#klarna-modal-product-price',//the span that contains the installment price in the modal (AUTHORED IN AEM)
      modalClass: '.interstitial-container',//the container class of the interstitial modal (AUTHORED IN AEM)
      hideClass: 'hide',//the hidden class - we add and remove this to show the messaging once it has loaded
      MINIMUM_PRICE: '35',//default minium price in case it isn't passed in
      MAXIMUM_PRICE: '1000',//default maximum price in case it isn't passed init
      klarnaMessage: '.pdp-klarna-message'//the class where the message will be injected

    },

    /**
     * init()
     * Initializes the plugin instance
     * @returns {Object} This plugin instance
    */
    init: function() {
      var self = this;

      if(DEBUG) console.debug('Initializing ', PLUGIN_IDENTIFIER, 'on', $(self.element));

      // Merge various methods of providing plugin options into a single config object
      self.metadata = $(self.element).data(PLUGIN_IDENTIFIER+'Options');
      self.config = $.extend(
        {}, // empty object to merge into
        self.defaults, // defaults hardcoded into the prototype defined in this file
        self.options, // options provided when initializing by JQuery $(selector).myPlugin(options)
        self.metadata // options provided as HTML data attribute $(selector).data()
      );

      // Initialize events
      self.events();

      // Allow JQuery-style chaining of the plugin
      return self;
    },

    /**
     * events() 
     * Binds plugin events
    */
    events: function() {
      var self = this;

      if( priceService.latestPrice){
        self.handlePriceChange(null, priceService.latestPrice);
      }
      //subscribe to our product.price.updated event
      $.pubsub('subscribe', 'product.price.updated', self.handlePriceChange.bind(self));

      $(self.config.modalID).on('open.zf.reveal', function() {
        if(DEBUG) console.log('KLARNA MODAL EVENT: open.zf.reveal');
        var modalEvent = self.isPriceEligible(self.config.price) ? self.injectPriceIntoModal() : self.showKlarnaModalMessaging();
      });
    },

    /**
     * isPriceEligible(price)
     * Determines if product price is eligible for Klarna installments
     * @param {String} price - the price of the product
    */
    isPriceEligible: function(price) {
      var self = this;

      if(price < parseInt(self.config.MINIMUM_PRICE) || price > parseInt(self.config.MAXIMUM_PRICE)) {
        return false;
      }else{
        return true;
      }
    },

    /**
     * showKlarnaMessaging(eligibility)
     * Shows specific messaging based on eligibility
     * @param {String} eligibility - eligible or ineligible
    */
    showKlarnaMessaging: function(eligibility) {
      var self = this;
      var $klarnaEl = $(self.config.klarnaDiv);
      switch(eligibility) {
        case 'eligible':
          $klarnaEl.find(self.config.klarnaMessage).html(self.config.AVAILABLE_MESSAGE).promise().done(function() {
            self.installments = self.calculateInstallments(self.config.price, self.config.PRICE_DIVISOR);
            self.injectPriceIntoPDP();
          });
          break;
        case 'ineligible':
          $klarnaEl.find(self.config.klarnaMessage).html(self.config.UNAVAILABLE_MESSAGE).promise().done(function() {
            $(this).removeClass(self.config.hideClass);
          });
          break;
        default:
         if(DEBUG) console.log('No Klarna Messaging will be displayed');
      }
    },

    /**
     * showKlarnaModalMessaging()
     * Shows specific messaging based on eligibility
    */
    showKlarnaModalMessaging: function() {
      if(DEBUG) console.log('showKlarnaModalMessaging()');
      var self = this;
      var $klarnaModal = $(self.config.modalID);

      $klarnaModal.find('h2.unavailable').removeClass(self.config.hideClass);
      $klarnaModal.find('h2.available').addClass(self.config.hideClass);
    },

    /**
     * removeCurrency()
     * Removes the currency symbol from the price
     * @param {String} price - the product price ex. $150.00
     * @returns {Number} - a floating point number without the symbol ex. 150.00
     * TODO: use the javascript i18n api to match locale with currency - since this is for US only at launch we are not doing this at this time
    */
    removeCurrency: function(price) {
      var self = this;
      var $currencySymbol = self.config.CURRENCY;
      return parseFloat(price.replace($currencySymbol, ''));
    },

    /**
     * calculateInstallments()
     * Calculates payment installments based on a divisor
     * @param {String} price - the dividend
     * @param {Number} installment - the divisor
     * @returns {String} - a string rounded up to nearest two decimal places
    */
    calculateInstallments: function(price, installment) {
      var self = this;
      return (price / installment).toFixed(2);
    },

    /**
     * injectPriceIntoPDP()
     * Injects the Klarna price into the DOM
    */
    injectPriceIntoPDP: function() {
      var self = this;
      var $klarnaEl = $(self.config.klarnaDiv);
      var $priceEl = $klarnaEl.find(self.config.priceID);
      return $priceEl.html(self.installments).promise().done(function() {
        //show our klarna messaging
        if(DEBUG) console.log('injectPriceIntoPDP() - Show Klarna Messaging');
        $(self.config.klarnaMessage).removeClass(self.config.hideClass);
      });
    },

    /**
     * handlePriceChange()
     * Handle price change
     */
    handlePriceChange: function(event, price) {
      if(DEBUG) console.log('EVENT: product.price.updated', price);
      var self = this;
      self.config.price = self.removeCurrency(price);
      var priceEvent = self.isPriceEligible(self.config.price) ? self.showKlarnaMessaging('eligible') : self.showKlarnaMessaging('ineligible');
    },

    /**
     * injectPriceIntoModal()
     * Injects the Klarna price into the Modal DOM
    */
    injectPriceIntoModal: function() {
      var self = this;
      var $modal = $(self.config.modalID);
      var $priceEl = $modal.find(self.config.modalPriceID);
      $priceEl.html(self.installments).promise().done(function() {
        //update the klarna price in the modal
        if(DEBUG) console.log('injectPriceIntoModal() - Show Klarna Modal');
        $(self.config.modalClass).removeClass(self.config.hideClass);
      });
    }
  };

  // Create the instance defaults from the prototype
  vfdpPlugin.defaults = vfdpPlugin.prototype.defaults;

  // Register as a JQuery plugin and prevent duplicate instantiation
  $.fn[PLUGIN_IDENTIFIER] = function(options) {
    return this.each(function() {
      var instance = $(this).data(PLUGIN_IDENTIFIER);
      if(!instance) {
        instance = new vfdpPlugin(this, options).init();
        $(this).data(PLUGIN_IDENTIFIER, instance);
      }
    });
  };
});
